import { call, put, takeEvery, all, fork } from "redux-saga/effects"

// Crypto Redux States
import {
  GET_CHARTS_DATA,
  GET_DASHBOARD_DATA,
  GET_DASHBOARD_LEAD_CHART_DATA,
  GET_DASHBOARD_SALE_CHART_DATA,
  GET_DASHBOARD_VEHICLE_CHART_DATA,
  GET_PROMOTER_DASHBOARD_DATA,
  GET_PROMOTER_PROFILE_DETAILS,

  GET_LEAD_TO_SALE_RATIO,
  GET_SALES_REPORT_DATA,
  GET_PURCHASE_REPORT_DATA,
} from "./actionTypes"
import {
  apiSuccess,
  apiFail,
  getDashboardDataSuccess,
  getDashboardDataFail,
  getPromoterProfileDetailsSuccess,
  getPromoterProfileDetailsFail,
  getDashboardLeadChartDataSuccess,
  getDashboardLeadChartDataFail,
  getDashboardVehicleChartDataSuccess,
  getDashboardVehicleChartDataFail,
  getDashboardSaleChartDataSuccess,
  getDashboardSaleChartDataFail,

  getLeadToSaleRatioSuccess,
  getLeadToSaleRatioFail,
  getSalesReportDataSuccess,
  getSalesReportDataFail,
  getPurchaseReportDataSuccess,
  getPurchaseReportDataFail,
} from "./actions"

import { get } from "helpers/api_helper"
import {
  getPromoterDashboardDataFail,
  getPromoterDashboardDataSuccess,
} from "store/actions"
import moment from "moment"

function getDashboardDataAPi() {
  return get("/static/admin/dashboard/data")
}

// promoter profile api
function promoterProfileApi() {
  return get(`/promoter`)
}

// promoter dashboard api

function promoterDashboardDataApi() {
  return get(`/static/promoter/dashboard/data`)
}

// Helper to check if branch is a valid value
const isValidBranch = (branch) => branch && branch !== "undefined" && branch !== "null" && branch !== ""

function getDashboardLeadChartDataAPi({ branch }) {
  const query = isValidBranch(branch) ? `?branch=${branch}` : ""
  return get(`/lead/admin/graph/monthly${query}`)
}
function getDashboardVehicleChartDataAPi({ branch }) {
  const query = isValidBranch(branch) ? `?branch=${branch}` : ""
  return get(`/vehicle/admin/graph/monthly${query}`)
}
function getDashboardSaleChartDataAPi({ branch }) {
  const query = isValidBranch(branch) ? `?branch=${branch}` : ""
  return get(`/sale/admin/graph/monthly${query}`)
}



function getSalesReportDataApi({ filter, customDate, selectedBranch }) {
  const branchQuery = isValidBranch(selectedBranch) ? `&branch=${selectedBranch}` : ""

  return get(
    `/static/admin/report/sales?filter=${filter}&customStart=${moment(customDate?.startDate).format("YYYY-MM-DD") || ""
    }&customEnd=${moment(customDate?.endDate).format("YYYY-MM-DD") || ""}${branchQuery}`
  )
}

function getPurchaseReportDataApi({ filter, customDate, selectedBranch }) {
  const branchQuery = isValidBranch(selectedBranch) ? `&branch=${selectedBranch}` : ""

  return get(
    `/static/admin/report/purchase?filter=${filter}&customStart=${moment(customDate?.startDate).format("YYYY-MM-DD") || ""
    }&customEnd=${moment(customDate?.endDate).format("YYYY-MM-DD") || ""}${branchQuery}`
  )
}

// Lead to Sale Ratio API
function getLeadToSaleRatioApi({ branch }) {
  const query = isValidBranch(branch) ? `?branch=${branch}` : ""
  return get(`/static/lead-to-sale-ratio${query}`)
}

function* getChartsData({ payload: periodType }) {
  try {
    var response
    yield put(apiSuccess(GET_CHARTS_DATA, response))
  } catch (error) {
    yield put(apiFail(GET_CHARTS_DATA, error))
  }
}

function* fetchDashboardData({ payload }) {
  try {
    const response = yield call(getDashboardDataAPi, payload)
    yield put(getDashboardDataSuccess(response))
  } catch (error) {
    yield put(getDashboardDataFail(error))
  }
}
function* promoterProfile({ payload }) {
  try {
    const response = yield call(promoterProfileApi, payload)
    yield put(getPromoterProfileDetailsSuccess(response))
  } catch (error) {
    yield put(getPromoterProfileDetailsFail(error))
  }
}

//promoter dashboard data

function* promoterDashboardData({ payload }) {
  try {
    const response = yield call(promoterDashboardDataApi, payload)
    yield put(getPromoterDashboardDataSuccess(response))
  } catch (error) {
    yield put(getPromoterDashboardDataFail(error))
  }
}

// --------------------------|| Charts  ||----------------------------------//

// lead

function* fetchDashboardLeadChartData({ payload }) {
  try {
    const response = yield call(getDashboardLeadChartDataAPi, payload)
    yield put(getDashboardLeadChartDataSuccess(response))
  } catch (error) {
    yield put(getDashboardLeadChartDataFail(error))
  }
}

// vehicle

function* fetchDashboardVehicleChartData({ payload }) {
  try {
    const response = yield call(getDashboardVehicleChartDataAPi, payload)
    yield put(getDashboardVehicleChartDataSuccess(response))
  } catch (error) {
    yield put(getDashboardVehicleChartDataFail(error))
  }
}
// sale

function* fetchDashboardSaleChartData({ payload }) {
  try {
    const response = yield call(getDashboardSaleChartDataAPi, payload)
    yield put(getDashboardSaleChartDataSuccess(response))
  } catch (error) {
    yield put(getDashboardSaleChartDataFail(error))
  }
}



// lead to sale ratio

function* fetchLeadToSaleRatio({ payload }) {
  try {
    const response = yield call(getLeadToSaleRatioApi, payload)
    yield put(getLeadToSaleRatioSuccess(response))
  } catch (error) {
    yield put(getLeadToSaleRatioFail(error))
  }
}

function* fetchSalesReportData({ payload }) {
  try {
    const response = yield call(getSalesReportDataApi, payload)
    yield put(getSalesReportDataSuccess(response))
  } catch (error) {
    yield put(getSalesReportDataFail(error))
  }
}

function* fetchPurchaseReportData({ payload }) {
  try {
    const response = yield call(getPurchaseReportDataApi, payload)
    yield put(getPurchaseReportDataSuccess(response))
  } catch (error) {
    yield put(getPurchaseReportDataFail(error))
  }
}

export function* watchGetChartsData() {
  yield takeEvery(GET_CHARTS_DATA, getChartsData)
}

function* dashboardSaga() {
  yield all([fork(watchGetChartsData)])

  yield takeEvery(GET_DASHBOARD_DATA, fetchDashboardData)
  yield takeEvery(GET_PROMOTER_PROFILE_DETAILS, promoterProfile)
  yield takeEvery(GET_PROMOTER_DASHBOARD_DATA, promoterDashboardData)

  yield takeEvery(GET_DASHBOARD_LEAD_CHART_DATA, fetchDashboardLeadChartData)
  yield takeEvery(
    GET_DASHBOARD_VEHICLE_CHART_DATA,
    fetchDashboardVehicleChartData
  )
  yield takeEvery(GET_DASHBOARD_SALE_CHART_DATA, fetchDashboardSaleChartData)

  yield takeEvery(GET_LEAD_TO_SALE_RATIO, fetchLeadToSaleRatio)

  yield takeEvery(GET_SALES_REPORT_DATA, fetchSalesReportData)
  yield takeEvery(GET_PURCHASE_REPORT_DATA, fetchPurchaseReportData)
}

export default dashboardSaga
